/**
 * ════════════════════════════════════════════════════════════════════
 * KEEP MEMORIZ — assets/km-contact-translate.js
 * Traductions FR/EN pour la page contact
 * Doit être chargé APRÈS window.KM_LANG (injecté dans theme.liquid)
 * ════════════════════════════════════════════════════════════════════
 */
(function () {
  var lang = (window.KM_LANG || 'fr').toLowerCase();
  if (lang === 'fr') return; // Page déjà en FR, rien à faire

  var T = {
    // Hero
    pill: '✉ Contact us',
    title: 'A question? <em>We\'ll answer.</em>',
    subtitle: 'Our team is available Monday to Sunday. We usually respond within 24 hours.',

    // Sidebar
    side_title: 'Our <em>contact details</em>',
    side_sub: 'Before your event, after your order, we\'re here for every step.',
    email_label: 'Email',
    email_note: 'Response within 24 business hours',
    avail_label: 'Availability',
    avail_val: 'Monday – Sunday · 7am – 10pm',
    avail_note: 'Paris time',
    faq_text: 'Your question may already be in our FAQ: orders, QR code, posters, downloads, refunds…',
    faq_link: 'Check the FAQ',

    // Form
    form_title: 'Send us <em>a message</em>',
    form_sub: 'Fill out the form and we\'ll get back to you as soon as possible.',
    success_strong: 'Message sent!',
    success_text: ' Thank you for contacting us. We\'ll respond within 24 business hours to the email address you provided.',
    label_first: 'First name',
    label_last: 'Last name',
    label_email: 'Email address',
    label_subject: 'Subject of your request',
    label_event: 'Your event (optional)',
    label_message: 'Your message',
    placeholder_first: 'Marie',
    placeholder_last: 'Dupont',
    placeholder_email: 'marie@example.com',
    placeholder_event: 'Wedding · June 15, 2025 · Bordeaux',
    placeholder_message: 'Describe your question or situation in a few lines…',
    select_default: 'Select a subject',
    select_1: 'Pre-purchase question',
    select_2: 'My order / gallery access',
    select_3: 'Posters & QR code',
    select_4: 'Refund request',
    select_5: 'Technical issue',
    select_6: 'Partnership / press',
    select_7: 'Other',
    form_note: '* Required fields. Your data will never be shared with third parties.',
    privacy_link: 'Privacy policy.',
    btn_send: 'Send'
  };

  function q(sel) { return document.querySelector(sel); }
  function qa(sel) { return document.querySelectorAll(sel); }
  function setText(el, txt) { if (el) el.textContent = txt; }
  function setHTML(el, txt) { if (el) el.innerHTML = txt; }

  // Hero
  var pill = q('.km-ct-pill');
  if (pill) setText(pill, T.pill);

  var heroH1 = q('.km-ct-hi h1');
  if (heroH1) setHTML(heroH1, T.title);

  var heroP = q('.km-ct-hi p');
  if (heroP) setText(heroP, T.subtitle);

  // Sidebar
  var sideH = q('.km-ct-side-h');
  if (sideH) setHTML(sideH, T.side_title);

  var sideSub = q('.km-ct-side-sub');
  if (sideSub) setText(sideSub, T.side_sub);

  // Email block
  var blkLabels = qa('.km-ct-blk-lbl');
  var blkNotes = qa('.km-ct-blk-note');
  var blkVals = qa('.km-ct-blk-val');

  if (blkLabels[0]) setText(blkLabels[0], T.email_label);
  if (blkNotes[0]) setText(blkNotes[0], T.email_note);

  // Availability block
  if (blkLabels[1]) setText(blkLabels[1], T.avail_label);
  if (blkVals[1]) setText(blkVals[1], T.avail_val);
  if (blkNotes[1]) setText(blkNotes[1], T.avail_note);

  // FAQ box
  var faqP = q('.km-ct-faq p');
  if (faqP) setText(faqP, T.faq_text);
  var faqA = q('.km-ct-faq a');
  if (faqA) {
    faqA.innerHTML = T.faq_link + ' <span>→</span>';
    // Fix URL for EN locale
    if (faqA.href && faqA.href.indexOf('/en/') === -1) {
      faqA.href = faqA.href.replace('/pages/faq', '/en/pages/faq');
    }
  }

  // Form header
  var fwH = q('.km-ct-fw-h');
  if (fwH) setHTML(fwH, T.form_title);

  var fwSub = q('.km-ct-fw-sub');
  if (fwSub) setText(fwSub, T.form_sub);

  // Success message
  var successP = q('#km-contact-success p');
  if (successP) setHTML(successP, '<strong>' + T.success_strong + '</strong>' + T.success_text);

  // Form labels and placeholders
  var prenomLabel = q('label[for="km-prenom"]');
  if (prenomLabel) setHTML(prenomLabel, T.label_first + ' <em>*</em>');
  var prenomInput = q('#km-prenom');
  if (prenomInput) prenomInput.placeholder = T.placeholder_first;

  var nomLabel = q('label[for="km-nom"]');
  if (nomLabel) setText(nomLabel, T.label_last);
  var nomInput = q('#km-nom');
  if (nomInput) nomInput.placeholder = T.placeholder_last;

  var emailLabel = q('label[for="km-email"]');
  if (emailLabel) setHTML(emailLabel, T.label_email + ' <em>*</em>');
  var emailInput = q('#km-email');
  if (emailInput) emailInput.placeholder = T.placeholder_email;

  var sujetLabel = q('label[for="km-sujet"]');
  if (sujetLabel) setText(sujetLabel, T.label_subject);
  var sujetSelect = q('#km-sujet');
  if (sujetSelect) {
    var opts = sujetSelect.options;
    var translations = [T.select_default, T.select_1, T.select_2, T.select_3, T.select_4, T.select_5, T.select_6, T.select_7];
    for (var i = 0; i < opts.length && i < translations.length; i++) {
      opts[i].textContent = translations[i];
    }
  }

  var eventLabel = q('label[for="km-event"]');
  if (eventLabel) setText(eventLabel, T.label_event);
  var eventInput = q('#km-event');
  if (eventInput) eventInput.placeholder = T.placeholder_event;

  var msgLabel = q('label[for="km-msg"]');
  if (msgLabel) setHTML(msgLabel, T.label_message + ' <em>*</em>');
  var msgInput = q('#km-msg');
  if (msgInput) msgInput.placeholder = T.placeholder_message;

  // Form footer
  var fNote = q('.km-f-note');
  if (fNote) {
    var privacyLink = fNote.querySelector('a');
    var privacyHref = privacyLink ? privacyLink.href : '/pages/confidentialite';
    fNote.innerHTML = T.form_note + ' <a href="' + privacyHref + '" style="color:var(--km-gold)">' + T.privacy_link + '</a>';
  }

  // Send button
  var btnSend = q('.km-btn-send');
  if (btnSend) {
    var svg = btnSend.querySelector('svg');
    btnSend.innerHTML = '';
    if (svg) btnSend.appendChild(svg);
    btnSend.appendChild(document.createTextNode('\n          ' + T.btn_send));
  }

})();